import apiClient from './api';

const DASHBOARD_ID = 'user_card_definitions';

const userCardService = {
  load: async () => {
    try {
      const response = await apiClient.get(`/dashboard/preferences/?dashboard_id=${DASHBOARD_ID}`);
      return response.data?.configuration?.cards || [];
    } catch {
      return [];
    }
  },

  save: async (cards) => {
    await apiClient.post('/dashboard/preferences/', {
      dashboard_id: DASHBOARD_ID,
      configuration: { cards },
    });
  },

  addCard: async (cardConfig) => {
    const cards = await userCardService.load();
    cards.push(cardConfig);
    await userCardService.save(cards);
    return cards;
  },

  removeCard: async (cardId) => {
    const cards = await userCardService.load();
    const filtered = cards.filter(c => c.id !== cardId);
    await userCardService.save(filtered);
    return filtered;
  },
};

export default userCardService;
